
$( document ).ready(function() {
if(5000 > 0){
  var amount_free_product = 5000;
     setTimeout(function () {
        var cart_total = parseFloat($('.gb-totals-total-value').first().text().replace(/[^0-9.]/g, '')) * 100 || 0;
        if(cart_total >= amount_free_product ) {
           if($(".cart-item").hasClass("gb-find-remove-product")) {
           }else{
             $('.gb-free-product-tirgger').trigger('click');
           }

         } else {
            $('.gb-remove-product').trigger('click');
         }
      }, 3000);
  $('body').on('click', '.gb-sumbit-free', function(){
     var amount_free_product = 5000;
     setTimeout(function () {
        var cart_total = parseFloat($('.gb-totals-total-value').first().text().replace(/[^0-9.]/g, '')) * 100 || 0;
        if(cart_total >= amount_free_product ) {
           if($(".cart-item").hasClass("gb-find-remove-product")) {
           }else{
             $('.gb-free-product-tirgger').trigger('click');
           }

         } else {
            $('.gb-remove-product').trigger('click');
         }
      }, 3000);

  });
  }

  });
  $('body').on('click', '.quantity__button', function(){
     var amount_free_product = 5000;
     setTimeout(function () {
        var cart_total = parseFloat($('.gb-totals-total-value').first().text().replace(/[^0-9.]/g, '')) * 100 || 0;
        if(cart_total >= amount_free_product ) {
           if($(".cart-item").hasClass("gb-find-remove-product")) {
           }else{
             $('.gb-free-product-tirgger').trigger('click');
           }
         } else {
            $('.gb-remove-product').trigger('click');
         }
      }, 3000);

  });
  $('body').on('keyup', '.quantity__input', function(){
     var amount_free_product = 5000;
     setTimeout(function () {
        var cart_total = parseFloat($('.gb-totals-total-value').first().text().replace(/[^0-9.]/g, '')) * 100 || 0;
        if(cart_total >= amount_free_product ) {
           if($(".cart-item").hasClass("gb-find-remove-product")) {
           }else{
             $('.gb-free-product-tirgger').trigger('click');
           }
         } else {
            $('.gb-remove-product').trigger('click');
         }
      }, 3000);

  });
  $('body').on('click', '.cart-remove-button', function(){
     var amount_free_product = 5000;
     setTimeout(function () {
        var cart_total = parseFloat($('.gb-totals-total-value').first().text().replace(/[^0-9.]/g, '')) * 100 || 0;
        if(cart_total >= amount_free_product ) {
           if($(".cart-item").hasClass("gb-find-remove-product")) {
           }else{
             $('.gb-free-product-tirgger').trigger('click');
           }
         } else {
            $('.gb-remove-product').trigger('click');
         }
      }, 3000);

  });

   $('body').on('click', '.gb-shipping-protection-button label.switch.unchecked', function(){
          $('.gb-product-shipping-protection-product-tirgger').trigger('click');
     $('.gb-shipping-protection-button label.switch.unchecked').removeClass("unchecked");

   });
    $('body').on('click', '.gb-shipping-protection-button label.switch.checked', function(){
          $('.gb-remove-product-shipping-protection').trigger('click');
      $('.gb-shipping-protection-button label.switch.checked').removeClass("checked");
   });

   $('body').on('change', '.gb-change-variant_id', function(){
      var id_change = $(this).find(":selected").attr('data-variant-id');
      if(!id_change) {
        return;
      }
      $(this).closest('.gb-get-main-freq-pro').find('.product-variant-id').val(id_change);
   });



document.addEventListener('change', function (e) {
  if (e.target.matches('.cart-drawer .gbfrequently-bought-with-main-whole .select__select')) {
    const parentBlock = e.target.closest('.gb-get-main-freq-pro');
    if (!parentBlock) {
      return;
    }

    const allValues = Array.from(parentBlock.querySelectorAll('.select__select'))
      .map(sel => sel.value)
      .join(' / ');

    const variantSelect = parentBlock.querySelector('[name="variants"]');
    if (!variantSelect) {
      return;
    }

    const matchedOption = Array.from(variantSelect.options).find(option =>
      option.text.includes(allValues)
    );

    const idInput = parentBlock.querySelector('[name="id"]');
    if (!idInput) {
      return;
    }

    if (matchedOption) {
      idInput.value = matchedOption.value;
    }
  }
});


// Improve cart quantity handlers
$(document).ready(function() {
  // Ensure all cart quantity changes include product ID
  $('.cart-item .quantity__button, .cart-item .quantity__input').on('click change input', function() {
    const cartItem = $(this).closest('.cart-item');
    const variantId = $(this).closest('.quantity-input').find('.quantity__input').data('quantity-variant-id');
    const quantityInput = cartItem.find('.quantity__input');

    // If this is a form submission, ensure the ID is included
    if ($(this).closest('form').length > 0) {
      let idInput = $(this).closest('form').find('input[name="id"]');
      if (idInput.length === 0 && variantId) {
        $('<input>').attr({
          type: 'hidden',
          name: 'id',
          value: variantId
        }).appendTo($(this).closest('form'));
      } else if (idInput.length > 0 && variantId) {
        idInput.val(variantId);
      }
    }
  });

  // Add validation for cart drawer checkout button
  $('#CartDrawer-Checkout').on('click', function(e) {
    const form = $('#CartDrawer-Form');
    if (form.length === 0) return;

    // Check if there are any items in the cart
    const cartItems = form.find('.cart-item');
    if (cartItems.length === 0) {
      e.preventDefault();
      return false;
    }
  });

  // Enhanced free product and cart update handling
  function checkFreeProductEligibility() {
    var amount_free_product = 5000;
    var cart_total = parseFloat($('.gb-totals-total-value').first().text().replace(/[^0-9.]/g, '')) * 100 || 0;

    try {
      if (cart_total >= amount_free_product) {
        if (!$(".cart-item").hasClass("gb-find-remove-product")) {
          $('.gb-free-product-tirgger').trigger('click');
        }
      } else {
        $('.gb-remove-product').trigger('click');
      }
    } catch (error) {
      // Silent error handling in production
    }
  }

  // Replace existing similar function calls with this unified one
  $('.quantity__button, .quantity__input, .cart-remove-button').on('click change keyup', function() {
    // Debounce the check to prevent multiple calls
    clearTimeout($(this).data('freeProductTimer'));
    $(this).data('freeProductTimer', setTimeout(checkFreeProductEligibility, 3000));
  });
});

// Fix for frequently bought products add to cart
$(document).ready(function() {
  // Find all frequently bought product forms or buttons
  $('.gbfrequently-bought-with-main-whole button, .gbfrequently-bought-with-main-whole .gb-sumbit-free, .gb-free-product-tirgger, .gb-product-shipping-protection-product-tirgger').on('click', function(e) {
    const parentBlock = $(this).closest('.gb-get-main-freq-pro, form');
    if (!parentBlock) {
      return;
    }

    // Find the product ID input or data attribute
    let productId = null;

    // Check for direct ID input
    const idInput = parentBlock.find('input[name="id"]');
    if (idInput.length > 0 && idInput.val()) {
      productId = idInput.val();
    }
    // Check for variant ID on select
    else if (parentBlock.find('.gb-change-variant_id').length > 0) {
      const selectedOption = parentBlock.find('.gb-change-variant_id option:selected');
      if (selectedOption.length > 0) {
        productId = selectedOption.data('variant-id');
      }
    }
    // Check for product-variant-id input
    else if (parentBlock.find('.product-variant-id').length > 0) {
      productId = parentBlock.find('.product-variant-id').val();
    }
    // Check for data attributes on the button itself
    else if ($(this).data('variant-id')) {
      productId = $(this).data('variant-id');
    }

    // If no product ID found, prevent submission
    if (!productId) {
      e.preventDefault();
      return false;
    }

    // Update or create the ID input
    if (idInput.length === 0) {
      $('<input>').attr({
        type: 'hidden',
        name: 'id',
        value: productId
      }).appendTo(parentBlock);
    } else {
      idInput.val(productId);
    }

    // Ensure quantity is included
    let quantityInput = parentBlock.find('input[name="quantity"]');
    if (quantityInput.length === 0) {
      $('<input>').attr({
        type: 'hidden',
        name: 'quantity',
        value: 1
      }).appendTo(parentBlock);
    } else if (!quantityInput.val() || quantityInput.val() < 1) {
      quantityInput.val(1);
    }
  });
});
